import { Popover } from "antd";
import styles from "./index.less";
import { useState } from "react";
import CloseIcon from "@/assets/images/components/DownloadDesktop/close-icon.svg";
import { ReactComponent as ButtonIcon } from "@/assets/images/components/DownloadDesktop/button-icon.svg";
import WindowIcon from "@/assets/images/components/DownloadDesktop/window-icon.png";
import DownloadIcon from "@/assets/images/components/DownloadDesktop/download-icon.png";

const TestWindowDownloadUrl =
  "https://actstatic.insnail.com/12times/official-website/12times-test-0.0.1-setup.exe";
const ProductionWindowDownloadUrl =
  "https://actstatic.insnail.com/12times/official-website/12times-0.0.1-setup.exe";

const getUrl = () => {
  if (location.host.startsWith("qas")) {
    return TestWindowDownloadUrl;
  } else {
    return ProductionWindowDownloadUrl;
  }
};

/** 桌面端下载 */
const DownloadDesktop = () => {
  const isElectron = window.electronApi;
  const [open, setOpen] = useState(false);
  const hide = () => {
    setOpen(false);
  };

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const download = () => {
    const downloadLink = document.createElement("a");
    downloadLink.href = getUrl();
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  if (isElectron) {
    return null;
  }
  return (
    <div className="flex justify-center">
      <Popover
        content={
          <div className={styles["download-desktop-popover-content"]}>
            <div className={styles.close}>
              <img
                src={CloseIcon}
                className={styles.closeIcon}
                onClick={hide}
              />
            </div>
            <div className={styles.title}>点击下载 12Times 桌面端</div>
            <div className={styles.download} onClick={download}>
              <div className={styles.common}>
                <img src={WindowIcon} className={styles["download-icon"]} />
                <div className={styles["download-text"]}>Windows</div>
              </div>

              <div className={styles.hover}>
                <img src={DownloadIcon} className={styles["download-icon"]} />
                <div className={styles["download-text"]}>点击下载</div>
              </div>
            </div>
          </div>
        }
        trigger="click"
        open={open}
        onOpenChange={handleOpenChange}
        arrow={false}
        styles={{
          body: {
            width: "320px",
            height: "294px",
            boxShadow: "0px 0px 20px 0px rgba(0,0,0,0.1)",
            borderRadius: "10px",
            marginBottom: "12px",
          },
        }}
        placement="topLeft"
      >
        <div className={styles["button-container"]}>
          <a className={styles["download-desktop-button"]}>
            <ButtonIcon />
            <span>桌面端下载</span>
          </a>
          <div className={styles["button-desc"]}>消息提醒更及时!</div>
        </div>
      </Popover>
    </div>
  );
};

export default DownloadDesktop;
